export const packageName = 'dsh-lark-bot';
